import { Injectable } from '@angular/core';
import { of, from } from 'rxjs';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ImageService {

  private static readonly CONVERT_TIMEOUT: number = 3000;

  constructor() { }

  public CutImage(dataURL: string, width: number, height: number, contentType = 'image/jpeg', quality = 0.8): Promise<string> {
    const promise = new Promise<string>((resolve, reject) => {
      const image = new Image();

      image.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const canvasContext = canvas.getContext('2d');
        canvasContext.drawImage(image, 0, 0, width, height, 0, 0, width, height);

        const newImageDataURL: string = canvas.toDataURL(contentType, quality);

        canvas.width = 0;
        canvas.height = 0;

        resolve(newImageDataURL);
      };

      image.onerror = reject;
      image.src = dataURL;

    });

    return this.AddTimeout(promise);
  }

  public ResizeBlobImage(
      blob: Blob,
      maxWidth: number = 1366,
      maxHeight: number = 1366,
      contentType = 'image/jpeg',
      quality = 0.9
  ): Promise<Blob> {

    if (!blob.type.match('image.*')) {
      return null;
    }

    const thisRef = this;
    return new Promise((resolve, reject) => {

      const fileLoader = new FileReader();
      const canvas = document.createElement('canvas');
      const image = new Image();
      image.onabort = reject;
      image.onerror = reject;
      fileLoader.onabort = reject;
      fileLoader.onerror = reject;
      fileLoader.onload = function () {
        image.src = this.result.toString();
      };

      image.onload = function () {
        if (image.width <= 0 || image.height <= 0) {
          reject();
          return;
        }

        const context = canvas.getContext('2d');
        const newSize = thisRef.calculateAspectRatioFit(image.width, image.height, maxWidth, maxHeight);
        canvas.width = newSize.width;
        canvas.height = newSize.height;

        context.clearRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, image.width, image.height, 0, 0, newSize.width, newSize.height);

        const generatedBlob = thisRef.dataURItoBlob(canvas.toDataURL(contentType, quality));

        canvas.width = 0;
        canvas.height = 0;

        resolve(generatedBlob);
      };

      fileLoader.readAsDataURL(blob);
    });
  }

  public ConvertDataURLToBlob(dataURL: string): Promise<Blob> {
    const promise = new Promise<Blob>((resolve, reject) => {
      try {
        const blob: Blob = this.dataURItoBlob(dataURL);
        resolve(blob);
      } catch (error) {
        reject(error);
      }
    });

    return this.AddTimeout(promise);
  }

  private calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    const ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth * ratio, height: srcHeight * ratio };
  }

  private dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    let byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
      byteString = atob(dataURI.split(',')[1]);
    } else {
      byteString = unescape(dataURI.split(',')[1]);
    }

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    const ia = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  private AddTimeout<T>(promise: Promise<T>): Promise<T> {
    return from(promise).pipe(
      timeout(ImageService.CONVERT_TIMEOUT),
    ).toPromise();
  }

}
